import { render, staticRenderFns } from "./RelatorioComercialSalesOrderView.vue?vue&type=template&id=4da1052f"
import script from "./RelatorioComercialSalesOrderView.vue?vue&type=script&lang=js"
export * from "./RelatorioComercialSalesOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports